// An upload returns a storage path; the signed url only comes back from the API
// on the next read. Anything rendering before that round-trip (the tracking
// preview, a re-opened ListObject item) has nothing to show, so keep the blob we
// just sent and hand out object URLs for it.
//
// The blob is kept rather than a URL because el-upload revokes every `blob:` url
// in its list when it unmounts (el-upload/index.js onBeforeUnmount), which kills
// a shared url the first time an item editor closes.
// ponytail: session-scoped, never released. Fine for the handful of files a form
// holds; clear it on route change if that stops being true.
const blobsByKey: Record<string, Blob> = {}
const urlsByKey: Record<string, string> = {}

// stored under the full path and the bare file name, so a lookup still hits when
// one side holds a signed url, a path, or just the name
function keysOf(path: string): string[] {
  const name = path.split('/').pop() || ''
  const bare = name.split('?')[0]
  return bare && bare !== path ? [path, bare] : [path]
}

function keyFor(path?: string): string | undefined {
  if (!path) return undefined
  return keysOf(path).find((key) => blobsByKey[key])
}

export function rememberLocalFile(path: string, file: Blob) {
  if (!path || !file) return
  keysOf(path).forEach((key) => {
    if (!blobsByKey[key]) blobsByKey[key] = file
  })
}

// Shared url for viewers, which never revoke. Cached so repeated renders do not
// pile up object URLs.
export function localFileUrl(path?: string): string | undefined {
  const key = keyFor(path)
  if (!key) return undefined
  if (!urlsByKey[key]) urlsByKey[key] = URL.createObjectURL(blobsByKey[key])
  return urlsByKey[key]
}

// A throwaway url for el-upload, which revokes what it is given on unmount.
export function localFileUrlForUpload(path?: string): string | undefined {
  const key = keyFor(path)
  return key ? URL.createObjectURL(blobsByKey[key]) : undefined
}
